<template>
    <div class="lock-comp">
      <div class="lock-section" :style="!userProfile ? { display: 'unset' } : {}" v-if="!userProfile || subscribedPlanDetails.plan == 'Lite' || !subscribedPlanDetails.plan">
        <div v-if="!userProfile" class="flex-center new-presignup-card">
        </div>
        <div class="note" v-else-if="userProfile">
          
          <div class="flex-space-between qr-outer" :class="[isSentimentCard ? 'market-sentiment' : '']">
           
            <div v-if="!currentUrl.includes('almondz.stockants.com') && userProfile.utm_source != 'Almondz' && !currentUrl.includes('almondztrade.stockants.com') && userProfile.utm_source != 'Almondz Trade'">
              <el-card class="text-left scan-qr-card">
                <div class="text-center">
                  <div style="font-size: 18px; font-weight: 600; margin: 10px">
                    <img src="../assets/images/Premium Icon.svg" alt="" style="width: 20px" />
                    Premium Plan
                  </div>
                </div>
                <div class="text-center">
                  <!-- Price -->
                  <div class="rupee">
                    ₹
                    {{ isMonthlyPlan ? credentials.PREMIUM_COST_THIRTY_DAYS : credentials.PREMIUM_COST_SEVEN_DAYS }}
                  </div>
                  <!-- Equity Option Checkbox -->
                  <el-checkbox-group v-model="selectedMarketOption" :min="2" style="margin: 5px 0">
                    <el-checkbox label="Equity" style="margin-right: 10px"></el-checkbox>
                    <el-checkbox label="Options"></el-checkbox>
                  </el-checkbox-group>
                  <!-- Toggle Button for 7 Days and 30 Days -->
                  <div class="switch-sec">
                    <p>7 Days</p>
                    <label class="switch">
                      <input v-model="isMonthlyPlan" @change="changePeriod()" type="checkbox" />
                      <span class="slider round"></span>
                    </label>
                    <p>30 Days</p>
                  </div>
                  <!-- Subscribe Button -->
                  <el-button class="btn-secondary-theme-filled subscribe-button" @click="getOrderId()">Subscribe</el-button>
                </div>
                <div class="font-07rem font-weight-600 agreement bottom-margin-10">
                  <el-checkbox v-model="subscription_agreement" class="right-margin-5" style="position: relative; top: 1px"></el-checkbox>
                  I accept
                  <span @click="downloadSubscriptionAgreement()" class="agree-text cursor-pointer" style="margin-left: 3px; margin-right: 3px">StockAnts agreement</span>
                  <span v-if="!userProfile.aadhar_card_number.length || !userProfile.pan_card_number.length || !userProfile.risk_category.length">& post payment client onboarding process</span>
                </div>
  
                <div v-if="websiteUserType.userType == 'broker'">
                  <div class="or-line">
                    <div class="straight-line"></div>
                    <div class="or-outer">
                      <div class="or-block">or</div>
                    </div>
                  </div>
                  <div class="access-code-section bottom-margin-10 top-margin-10 flex-space-between">
                    <el-input placeholder="Enter access code(Optional)" v-model="access_code" size="mini" style="width: 65%; border-radius: 7px"></el-input>
                    <el-popover placement="bottom" width="250" trigger="click" style="position: relative; right: 28px; color: #918e8e">
                      <!-- content="Enter the access code get premium access" -->
                      <div>
                        Enter the access code displayed on
                        <span class="external-link-color">
                          <a href="https://stockants.com/" target="__blank" style="color: #4488d0">stockants.com</a>
                          <span><i class="el-icon-arrow-right" style="position: relative; top: 2px"></i></span>
                          Login
                          <span><i class="el-icon-arrow-right" style="position: relative; top: 2px"></i></span>
                          My Account
                        </span>
                      </div>
                      <i slot="reference" class="el-input__icon el-icon-info"></i>
                    </el-popover>
  
                    <el-button class="btn-secondary-theme-filled" style="width: 30%; margin-left: -8px" v-loading="access_code_verification_loading" :disabled="!access_code.length" @click="verifyAccessCode()">Apply</el-button>
                  </div>
                </div>
                <div class="features">
                 
            <div class="gradient-text flex">
              Benefits of StockAnts Premium
              <img src="../assets/images/Youtube Icon.png" @click="videoDialog = true" style="cursor: pointer; margin-left: 15px; cursor: pointer" alt="" width="20px" />
            </div>
            <div class="list">
              <i class="el-icon-success"></i>
              Bundle of SEBI Research Analysts
            </div>
            <div class="list">
              <i class="el-icon-success"></i>
              15+ Daily Strategies
            </div>
            <div class="list">
              <i class="el-icon-success"></i>
              Price estimate tracking of Research
              <span class="external-link-color font-06rem cursor-pointer" @click="$router.push('/pricing')" v-if="currentEnvironment.loginModule != 'BlinkX' && websiteUserType.userSubType != 'brokerWithoutPlans'">+More</span>
            </div>

            <div v-if="currentUrl.includes('almondz.stockants.com') || userProfile.utm_source == 'Almondz' || currentUrl.includes('almondztrade.stockants.com') || userProfile.utm_source == 'Almondz Trade'">
              <a href="https://subscription.almondztrade.com/stockants" target="_blank"><el-button class="btn-secondary-theme-filled subscribe-button">Subscribe</el-button></a>
            </div>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
  
      <el-dialog class="mobile-verification-dialog qr-dialog" :visible.sync="qRCodePopup" :lock-scroll="true" v-if="currentQRCode">
        <div style="word-break: break-word" class="text-center">
          <img :src="currentQRCode" style="width: 200px; cursor: pointer; position: relative; bottom: 44px" />
  
          <div class="norml-txt">
            Time remaining
            {{ formatTimeComponent(qrTimeoutMinutes) }} :
            {{ formatTimeComponent(qrTimeoutSeconds) }}
          </div>
        </div>
      </el-dialog>
  
      <div id="video-section">
        <el-dialog :visible.sync="videoDialog" :before-close="videoDialogClose" center>
          <div class="iframe-container">
            <iframe id="videoId" width="100%" height="600px" src="https://www.youtube.com/embed/umwESJwcelY?si=J6GKzIUX_MBTJqYp" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </el-dialog>
      </div>
  
      <!-- update profile details dialog -->
      <el-dialog class="unsubscribe-plan-notification-dialog" :visible.sync="update_profile_details_notiifcation_dialog" :before-close="handleProfileDetailsNoticiationDialogClose" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
        <div style="word-break: break-word">
          <div class="text-center" style="font-size: 17px; color: #000; font-weight: 600">Mobile No. verification is pending.</div>
          <div class="label-md-bold-black text-center top-margin-5" style="font-size: 17px; color: #000; font-weight: 600">Please verify.</div>
          <span slot="footer" class="dialog-footer flex-center top-margin-25">
            <div class="font-09rem">
              Click
              <u
                class="primary-theme-color cursor-pointer"
                @click="
                  update_profile_details_notiifcation_dialog = false;
                  $router.push({ path: '/profile-update' });
                "
              >
                here
              </u>
              to verify
            </div>
          </span>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { serverAddr, serverHostName } from '../networkConfig';
  import CripNotice from 'crip-vue-notice';
  import { credentials, cashfreeCredentials } from '../mixins/Credentials.js';
  import cashfreePromise from '../mixins/cashfreeInit.js';
  import moment from 'moment';
  import { required, minLength, maxLength } from 'vuelidate/lib/validators';
  import { loginNetworkCallBack } from '../mixins/login.NetworkCallback';
  
  export default {
    name: 'LockComponent',
    props: ['isSentimentCard'],
    mixins: [loginNetworkCallBack],
    data() {
      return {
        password: '',
        moment: moment,
        videoDialog: false,
        credentials: credentials,
        userProfile: null,
        access_code: '',
        currentEnvironment: {},
        accessCodePopup: false,
        qr_loading: false,
        access_code_verification_loading: false,
        websiteUserType: localStorage.getItem('websiteUserType') ? JSON.parse(localStorage.getItem('websiteUserType')) : {},
        isMonthlyPlan: false,
        subscription_agreement: false,
        selectedMarketOption: ['Equity', 'Options'],
        order_id: '',
        currentQRCode: '',
        serverHostName: serverHostName,
        QRTimeout: null,
        mobile_otp: '',
        mobile_number: '',
        isQRvalid: false,
        is_otp_sent: false,
        show_error_on_empty: false,
        update_profile_details_notiifcation_dialog: false,
        intervalId: null,
        session_id: null,
        internalTeamMailList: ['krishaa0801@gmail.com', 'joshiakshay719@gmail.com', 'fegde.mayur@gmail.com', 'snehalvpatil25@gmail.com', 'sumittarkas0001@gmail.com', 'bid.pallavi@gmail.com', 'pallavi.bid@stockants.com', 'bhushanm705811@gmail.com', 'admin@stockants.com', 'sumittarkas001@gmail.com', 'satavchetan08@gmail.com', 'amanm3047@gmail.com'],  
        username: '',
        emailUsername: false,
        mobileUsername: false,
        is_login_btn_loading: false,
        show_password: false,
        currentUrl: localStorage.getItem('currentUrl') ? localStorage.getItem('currentUrl') : window.location.href,
        isValidMobileNumber: true,
        selectedCountryCode: '+91',
        countryCodes: [
          {
            name: 'India',
            country_code: '+91',
            flag: require('@/assets/images/Country-flags/India.svg'),
            length: 10,
          },
          {
            name: 'Singapore',
            country_code: '+65',
            flag: require('@/assets/images/Country-flags/Singapore.svg'),
            length: 8,
          },
          {
            name: 'United States',
            country_code: '+1',
            flag: require('@/assets/images/Country-flags/United States.svg'),
            length: 10,
          },
          {
            name: 'Canada',
            country_code: '+1',
            flag: require('@/assets/images/Country-flags/Canada.svg'),
            length: 10,
          },
          {
            name: 'Dubai',
            country_code: '+971',
            flag: require('@/assets/images/Country-flags/Dubai.svg'),
            length: 9,
          },
          {
            name: 'Saudi Arabia',
            country_code: '+966',
            flag: require('@/assets/images/Country-flags/Saudi Arabia.svg'),
            length: 9,
          },
          {
            name: 'Oman',
            country_code: '+968',
            flag: require('@/assets/images/Country-flags/Oman.svg'),
            length: 8,
          },
          {
            name: 'United Kingdom',
            country_code: '+44',
            flag: require('@/assets/images/Country-flags/United Kingdom.svg'),
            length: 10,
          },
          {
            name: 'Australia',
            country_code: '+61',
            flag: require('@/assets/images/Country-flags/Australia.svg'),
            length: 9,
          }
        ]
      };
    },
  
    validations() {
  
      return {
        username: {
          required,
          emailOrPhone,
        },
        password: {
          required,
        },
  
        mobile_otp: {
          required,
        },
      };
    },
  
    mounted() {
      this.$nextTick(() => {
        this.$nextTick(() => {
          const buttonRef = this.$refs.googleSignIn;
          if (buttonRef) {
            setTimeout(() => {
              window.gapi.load('auth2', () => {
                let element = this.$refs['googleSignIn'];
  
                const auth2 = window.gapi.auth2.init({
                  // WILL NEED TO CHANGE BEFORE MAKING LIVE
                  // client_id: "929805204561-vop60edk3dh66alqfcvtdnhkhejq9l83.apps.googleusercontent.com",
                  client_id: '1091584009811-nch10s2crqsonpr1vvp58hgof9eqsgnd.apps.googleusercontent.com',
                  scope: 'email openid',
                  cookiepolicy: 'single_host_origin',
                });
  
                auth2.attachClickHandler(
                  element,
                  {},
                  (googleUser) => {
                    var profile = googleUser.getBasicProfile();
  
                    var postData = {
                      username: profile.getEmail(),
                      sign_up_source: 'GMAIL',
                      token: googleUser.getAuthResponse().id_token,
                      referral_code: this.referral_code ? this.referral_code : '',
                      full_name: profile.getName(),
                      first_name: profile.getGivenName(),
                      last_name: profile.getFamilyName(),
                      profession: this.userType == 'Market Expert' ? 'MARKET_EXPERT' : 'RETAIL_INVESTOR',
                    };
  
                    if (this.currentEnvironment && this.currentEnvironment.isStockAntsAuth) {
                      postData.broker_id = Number(localStorage.getItem('selected_broker'));
                    }
  
                    serverAddr
                      .post('/auth/v1/sign_in_with_social', postData)
                      .then((response) => {
                        this.socialLoginUserNetworkCallBack(response, profile.getEmail());
                      })
                      .catch(function (error) {
                        console.log(error);
                      });
                  },
                  (error) => console.log(error)
                );
              });
  
              window.fbAsyncInit = function () {
                FB.init({
                  appId: '1292261177910148',
                  // appId      : '938002080014163',
                  cookie: true,
                  xfbml: true,
                  version: 'v8.0',
                });
  
                FB.AppEvents.logPageView();
              };
  
              (function (d, s, id) {
                var js,
                  fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {
                  return;
                }
                js = d.createElement(s);
                js.id = id;
                js.src = 'https://connect.facebook.net/en_US/sdk.js';
                fjs.parentNode.insertBefore(js, fjs);
              })(document, 'script', 'facebook-jssdk');
            }, 500);
          }
        });
      });
  
      this.userProfile = localStorage.getItem('profile') ? JSON.parse(localStorage.getItem('profile')) : null;
  
      this.currentEnvironment = localStorage.getItem('currentEnvironment') ? JSON.parse(localStorage.getItem('currentEnvironment')) : {};
  
      this.websiteUserType = localStorage.getItem('websiteUserType') ? JSON.parse(localStorage.getItem('websiteUserType')) : {};
  
      this.$store.commit('commitQRCodePopup', false);
    },
  
    methods: {
     
      goToLink(link) {
        this.$router.push(link);
      },
      loginWithBroker() {
        this.$store.commit('commitBrokerLoginDialogVisibility', true);
      },
      setUsername(value) {
        this.username = value;
      },
      setMobileOtp(value) {
        this.mobile_otp = value;
        this.$v.mobile_otp.$touch();
      },
  
      setPassword(value) {
        this.password = value;
        this.$v.password.$touch();
      },
  
      changePeriod() {
        this.premium_pricing_duration = this.isMonthlyPlan == true ? '30' : '7';
        this.isQRvalid = false;
        this.currentQRCode = '';
        this.QRTimeout = null;
        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
      },
      videoDialogClose() {
        this.videoDialog = false;
        let video = document.getElementById('videoId');
        let url = video.getAttribute('src');
        video.setAttribute('src', '');
        video.setAttribute('src', url);
      },
      closePopup() {
        this.$store.commit('commitQRCodePopup', false);
      },
      showQRCode() {
        if (this.subscription_agreement) {
          // Init websocket if connection is disconnected
          this.$store.commit('commitQRCodePopup', true);
        } else {
          new CripNotice({
            title: 'Oops! Something went wrong!',
            description: 'Accept StockAnts Agreement before process payment',
            type: 'warning',
            duration: 3,
          });
        }
      },
  
      formatTimeComponent(timeComponent) {
        // Function to format time components with leading zeros
        return timeComponent < 10 ? `0${timeComponent}` : timeComponent;
      },
  
      downloadSubscriptionAgreement() {
        window.open(`${this.serverHostName}/Media/important_doc/StockAntsSubscriptionAgreement.pdf`, '_blank');
      },
  
      checkSubscribePlanDetails() {
        // if (
        //   !Object.keys(this.subscribedPlanDetails).length ||
        //   this.subscribedPlanDetails.plan == "Lite"
        // ) {
        // this.$store.commit("commitSubscribPlanDialogVisibility", true);
        localStorage.setItem('premiumPlanSubscriptionDialogVisible', true);
  
        this.$router.push({ path: '/pricing' });
        return;
        // }
      },
      verifyAccessCode() {
        if (this.access_code) {
          this.access_code_verification_loading = true;
          serverAddr
            // .post("/v1/aliceblue/validate_referral_code", {
            .post('/payment/v1/clone/plan/access_code', {
              access_code: this.access_code,
            })
            .then((response) => {
              if (response.data.status) {
                new CripNotice({
                  title: 'Success',
                  description: response.data.validation,
                  type: 'success',
                  duration: 3,
                });
              }
              this.access_code_verification_loading = false;
            })
            .catch(
              function (error) {
                this.access_code_verification_loading = false;
              }.bind(this)
            );
        }
      },
      generateQRCode() {
        if (this.subscription_agreement) {
          this.qr_loading = true;
  
          serverAddr
            .post('/payment/v1/generate_qr_code', {
              plan_name: 'Premium',
              days: this.isMonthlyPlan ? 30 : 7,
              amount: this.isMonthlyPlan ? credentials.PREMIUM_COST_THIRTY_DAYS : credentials.PREMIUM_COST_SEVEN_DAYS, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise,
              order_category_id: 3,
              description: 'Plan Subscription',
            })
            .then((response) => {
              if (response.data.status) {
                var data = response.data.data;
                this.currentQRCode = data.image_url;
                this.qr_loading = false;
                this.$store.commit('commitQRCodePopup', true);
                this.isQRvalid = true;
  
                var epocTime = moment.unix(data.close_by);
  
                // Format the date as a string
                // const formattedDate = this.QRTimeout.format("YYYY-MM-DD HH:mm:ss");
  
                // Get the current time as a Moment.js object
                var currentTime = moment();
  
                // Calculate the difference between the formatted date and the current time
                this.QRTimeout = moment.duration(currentTime.diff(epocTime));
  
                var remainingTimeinSec = currentTime.diff(epocTime, 'seconds');
                // var remainingTimeinSec = -10;
  
                if (remainingTimeinSec < 0) {
                  this.intervalId = setInterval(() => {
                    // Get the current time as a Moment.js object
                    currentTime = moment();
  
                    // Calculate the difference between the formatted date and the current time
                    this.QRTimeout = moment.duration(currentTime.diff(epocTime));
                    remainingTimeinSec++;
  
                    if (remainingTimeinSec > 0) {
                      clearInterval(this.intervalId);
                    }
                    if (remainingTimeinSec == 0) {
                      if (this.qRCodePopup == true) {
                        new CripNotice({
                          title: 'Oops! QR code has expired!',
                          description: 'QR code has expired! Please regenerate a new one',
                          type: 'error',
                          duration: 3,
                        });
                      }
                      this.$store.commit('commitQRCodePopup', false);
                      this.QRTimeout = null;
                      this.isQRvalid = false;
                    }
                  }, 1000);
                }
  
                // Output the difference in various units (days, hours, minutes, seconds)
  
                // setTimeout(() => {
                // }, 1000);
              }
            })
            .catch(
              function (error) {
                console.log(error);
                this.order_id = '';
  
                new CripNotice({
                  title: 'Oops! Something went wrong!',
                  description: 'Please try again',
                  type: 'error',
                  duration: 3,
                });
              }.bind(this)
            );
        } else {
          new CripNotice({
            title: 'Oops! Something went wrong!',
            description: 'Accept StockAnts Agreement before process payment',
            type: 'warning',
            duration: 3,
          });
        }
      },
      handleProfileDetailsNoticiationDialogClose() {
        this.update_profile_details_notiifcation_dialog = false;
      },
      getOrderId() {
        this.userProfile = JSON.parse(localStorage.getItem('profile'));
        if (this.subscription_agreement) {
          this.order_id = '';
          var currentPrice = this.isMonthlyPlan ? credentials.PREMIUM_COST_THIRTY_DAYS : credentials.PREMIUM_COST_SEVEN_DAYS;
  
          if (this.internalTeamMailList.includes(this.userProfile.email)) {
            currentPrice = 1;
          }
  
          serverAddr
            .post('/payment/v3/generate_order_id/', {
              plan_name: 'Premium',
              days: this.isMonthlyPlan ? 30 : 7,
              amount: currentPrice,
              order_category_id: 3,
              description: 'Plan Subscription',
              pg: 'CASHFREE',
            })
            .then((response) => {
              if (response.data.status) {
                this.order_id = response.data.data.order_id; //getting order id
                this.session_id = response.data.data.session_id;
                // init  payment mode
                // this.handlePaymentSelection();
                this.initCashfree();
              } else {
                new CripNotice({
                  title: 'Oops! Something went wrong!',
                  description: 'Please try again',
                  type: 'error',
                  duration: 3,
                });
              }
            })
            .catch(
              function (error) {
                console.log(error);
                this.order_id = '';
  
                new CripNotice({
                  title: 'Oops! Something went wrong!',
                  description: 'Please try again',
                  type: 'error',
                  duration: 3,
                });
              }.bind(this)
            );
        } else {
          new CripNotice({
            title: 'Oops! Something went wrong!',
            description: 'Accept StockAnts Agreement before process payment',
            type: 'warning',
            duration: 3,
          });
        }
      },
  
      async initCashfree() {
        try {
          // Wait for the cashfreePromise to resolve, which contains the initialized Cashfree SDK
          const cashfree = await cashfreePromise;
  
          // Check if this.session_id is defined and not empty
          if (!this.session_id) {
            console.error('Error: paymentSessionId is missing or undefined');
            return; // Exit the function if session_id is missing or undefined
          }
  
          // Construct options for checkout
          const checkoutOptions = {
            paymentSessionId: this.session_id,
            appId: cashfreeCredentials.appId,
            orderId: this.order_id,
            orderAmount: this.isMonthlyPlan ? credentials.PREMIUM_COST_THIRTY_DAYS : credentials.PREMIUM_COST_SEVEN_DAYS,
            orderCurrency: 'INR',
            customerName: credentials.NAME,
            redirectTarget: '_modal',
            // Add other necessary options
          };
  
          // Initiate payment using checkout
          cashfree.checkout(checkoutOptions).then((result) => {
            console.log(result);
            // this.sendTransactionIdToServer(result);
  
            if (result.error) {
              // This will be true whenever user clicks on close icon inside the modal or any error happens during the payment
              console.log('User has closed the popup, Check for Payment Status');
              console.log(result.error);
            }
            if (result.redirect) {
              // This will be true when the payment redirection page couldnt be opened in the same window
              // This is an exceptional case only when the page is opened inside an inAppBrowser
              // In this case the customer will be redirected to return url once payment is completed
              console.log('Payment will be redirected');
            }
            if (result.paymentDetails) {
              // This will be called whenever the payment is completed irrespective of transaction status
              console.log('Payment has been completed, Check for Payment Status');
              console.log(result.paymentDetails.paymentMessage);
              this.getCashfreeTransactionDetails();
            }
            if (result.payment_status) {
              console.log('Transaction Details:', result.payment_status);
            }
          });
        } catch (error) {
          console.error('Error initializing Cashfree SDK:', error);
        }
      },
  
      getCashfreeTransactionDetails() {
        if (this.order_id) {
          setTimeout(() => {
            serverAddr
              .get(`payment/v3/plan_details_from_order_id/${this.order_id}`)
              .then((response) => {
                // this.is_confirm_plan_purchase_dialog_visible = false;
                var plan_data = response.data.response;
  
                if (plan_data.extra_info.module == 'PLAN_PURCHASED' && plan_data.data.plan == 'Premium') {
                  this.$store.commit('storePlanStatus', plan_data);
                  this.$store.commit('commitQRCodePopup', false);
                  if (plan_data.data.plan.length) {
                    this.$store.commit('storePaymentStatus', true);
                  }
                }
  
                if (plan_data && plan_data.extra_info.transaction_status == 'SUCCESS') {
                  if (plan_data.data.plan == 'Publisher') {
                    localStorage.setItem('publisher_plan_details', JSON.stringify(plan_data.data));
                  } else {
                    localStorage.setItem('plan_details', JSON.stringify(plan_data.data));
                  }
  
                  this.$store.commit('commitKycDialog', true);
                  this.$router.push('/data-categorisation');
                }
              })
              .catch(
                function (error) {
                  console.log(error);
                }.bind(this)
              );
          }, 2000);
        }
      },
    },
    computed: {
     selectedCountry() {
      return this.countryCodes.find(country => country.country_code === this.selectedCountryCode) || null;
    },
      // returns selected market details from live price ticker component
      selectedMarketType() {
        return this.$store.state.selected_market_type;
      },
  
      qRCodePopup: {
        get() {
          return this.$store.state.isQRcodePopupVisible;
        },
        set(value) {
          this.$store.commit('commitQRCodePopup', value);
        },
      },
  
      subscribedPlanDetails() {
        return JSON.parse(localStorage.getItem('plan_details'));
      },
  
      qrTimeoutMinutes() {
        return this.QRTimeout ? -this.QRTimeout.minutes() : 0;
      },
      qrTimeoutSeconds() {
        return this.QRTimeout ? -this.QRTimeout.seconds() : 0;
      },
    },
    beforeDestroy() {
      clearInterval(this.intervalId);
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @import '../css/variable.scss';
  @import '../css/common.scss';
  
  .lock-comp {
    .or-line {
      position: relative;
      margin: 15px 0 20px;
      color: #6d6d6d;
  
      .straight-line {
        border-bottom: 1px solid #a19f9f;
        padding-top: 8px;
      }
  
      .or-outer {
        position: absolute;
        width: 100%;
        font-weight: 500;
  
        .or-block {
          width: 30px;
          padding: 5px;
          position: relative;
          margin: 0 auto;
          bottom: 16px;
          background: #fff;
          text-align: center;
        }
      }
    }
  
    .new-presignup-card {
      height: 300px;
  
      .google-btn {
        color: rgb(0 0 0);
        padding: 5px;
        border: 1px solid #cdcdcd;
        border-radius: 4px;
        font-weight: 500;
      }
  
      // .btn-secondary-theme-borderd {
      //   color: #343435;
      //   border: 1px solid #bdbdbd;
      // }
      // .btn-secondary-theme-borderd:hover {
      //   background-color: #ffff;
      // }
  
      .offer-img {
        position: absolute;
        top: -20px;
        left: -17px;
        width: 59%;
      }
  
      .left-section {
        width: 50%;
      }
  
      .left-section {
        .list {
          margin: 20px 0;
          font-size: 13px;
          font-weight: 500;
          color: #000000;
  
          .el-icon-success {
            background: #2d2e8d;
            // #2488fe,
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-size: 16px;
            position: relative;
            top: 1px;
          }
        }
  
        .points {
          font-size: 13px;
          margin: 15px 0;
          font-weight: 500;
  
          i {
            font-size: 16px;
            position: relative;
            top: 2px;
            color: #2d2e8d;
          }
        }
      }
  
      .right-section {
        width: 370px;
      }
  
      .prelogin-box {
        flex-wrap: wrap;
      }
  
      .pre-login-points-outer {
        width: 60%;
      }
  
      .pre-login-points {
        text-align: left;
        margin-right: 30px;
        width: 300px;
        margin: 0 auto;
      }
    }
  
    .password-visibility {
      position: absolute;
      right: 10px;
      top: 9px;
      width: 15px;
      cursor: pointer;
      z-index: 1;
    }
  
    .benefits-btn {
      padding: 5px;
      border: 1px solid #e1f0ff;
      border-radius: 7px;
      color: #409eff;
      background: #e1f0ff;
      font-weight: 600;
      margin-left: 10px;
      font-size: 0.8rem;
    }
  
    .lock-section {
      // flex-direction: column;
      .mobile-view {
        display: none;
      }
  
      .market-sentiment {
        flex-direction: column !important;
        align-items: flex-start !important;
      }
  
      .gradient-text {
        color: #000;
        font-size: 15px;
        margin-bottom: 20px;
        font-weight: 600;
      }
  
      .login-red-txt {
        color: red;
        font-weight: 600;
        font-size: 17px;
        margin-bottom: 10px;
      }
  
      .note {
        font-weight: 700;
        font-size: 14px;
        color: $ternary-theme-color;
        text-align: center;
        word-break: normal;
  
        .features {
          margin-top: 20px;
  
          .points {
            font-size: 13px;
            margin: 15px 0;
            font-weight: 500;
  
            i {
              font-size: 16px;
              position: relative;
              top: 2px;
              color: #2d2e8d;
            }
          }
        }
  
        // .login-btn {
        //   width: 170px;
        //   border-radius: 7px;
        //   color: #2d2e8d;
        //   border: 1px solid;
        //   margin-top: 5px;
        //   font-size: 15px;
        // }
  
        /* Background image styling for promotional banner*/
        .promotional-banner-image {
          background-image: url('../assets/images/Background img (2) (1).svg');
          background-size: cover;
          background-position: center;
          position: absolute;
          width: 100vw;
          height: 80px;
          display: flex;
          justify-content: flex-start !important;
          align-items: center;
          margin-left: -20px;
          margin-top: -20px;
          top: 0;
          left: 0;
          right: 0;
  
          .more-content {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 20px;
            gap: 25px;
            // margin-left: 0px !important;
          }
  
          .limited-offer-img {
            width: 150px;
          }
  
          .text-section {
            display: flex;
            flex-direction: column;
          }
  
          .main-text {
            font-size: 17px;
            font-weight: 800;
            color: #ffffff;
            margin: 0;
          }
  
          .discount-offer-img {
            width: 120px;
            z-index: 1;
          }
        }
      }
  
      .agreement {
        .agree-text {
          color: #409eff;
          text-decoration: underline;
        }
      }
  
      .qr-outer {
        justify-content: center;
        padding: 0 20px;
        position: relative !important;
        margin-top: -135px;
  
        .left-section {
          margin-right: 80px;
  
          .list {
            margin: 20px 0;
            font-size: 13px;
            font-weight: 500;
  
            .el-icon-success {
              background-image: linear-gradient(to right, #409eff, #2d2e8d);
              // #2488fe,
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              font-size: 16px;
              position: relative;
              top: 1px;
            }
          }
        }
      }
  
      .scan-qr-card {
        width: 400px;
        border-radius: 8px;
  
        .rupee {
          font-size: 30px;
          font-weight: 600;
          margin: 10px 0px;
        }
      }
  
      .switch-sec {
        display: flex;
        justify-content: center;
        align-items: center;
  
        p {
          font-size: 10px;
          font-weight: 600;
          margin: 15px;
        }
      }
  
      .switch {
        position: relative;
        display: inline-block;
        width: 38px;
        height: 19px;
        margin: 0 12px 0 6px;
      }
  
      .switch input {
        opacity: 0;
        width: 0;
        height: 0;
      }
  
      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: -6px;
        bottom: 0;
        width: 56px;
        height: 26px;
        background: #2d2e8d;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
  
      .slider:before {
        position: absolute;
        content: '';
        height: 21px;
        width: 24px;
        left: 3px;
        bottom: 3px;
        background-color: white;
        border-radius: 50%;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
  
      input:checked + .slider {
        //   background: transparent linear-gradient(270deg, #2d2e8d 0%, #40cbff 100%)
        //     0% 0% no-repeat padding-box;
        background: #2d2e8d;
      }
  
      input:focus + .slider {
        box-shadow: 0 0 1px #2196f3;
      }
  
      input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
      }
  
      /* Rounded sliders */
      .slider.round {
        border-radius: 34px;
      }
  
      .slider.round:before {
        border-radius: 50%;
      }

      .features {
  border-radius: 10px;
  margin-top: 15px;

  .gradient-text {
    font-size: 16px;
    font-weight: 600;
    background-image: linear-gradient(to right, #2D2E8D, #2D2E8D); // Single color gradient
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .list {
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: 500;
    margin: 10px 0;

    i.el-icon-success {
      font-size: 16px;
      color: #2D2E8D;
      margin-right: 8px;
    }
  }

  .external-link-color {
    color: #2488FF; // Color for "+More" link
    font-weight: 600;
    cursor: pointer;
  }
}

.subscribe-button {
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  margin-top: 10px;
}
    }
  
    .subscribe-button {
      margin-top: 10px;
      padding: 12px 30px;
      width: 90%;
      border-radius: 10px;
      margin: 10px 0px;
      font-size: 15px;
      font-weight: 600;
      color: #fff !important;
      text-decoration: none;
    }
  
    .subscribe-button:hover {
      color: #2d2e8d !important;
    }
  }
  
  @media screen and (min-width: 1681px) {
    .lock-comp .new-presignup-card .left-section .list {
      margin: 70px 0 20px;
    }
  }
  
  @media screen and (max-width: 1200px) {
    .lock-comp .lock-section .market-sentiment {
      flex-direction: row !important;
      align-items: center !important;
    }
    .qr-outer {
        margin-top: -55px;
      }
  }
  
  @media screen and (max-width: 1099px) {
    .lock-comp .new-presignup-card {
      flex-direction: column-reverse;
      margin-top: 70px;
  
      .offer-img {
        display: none;
      }
  
      .left-section {
        width: 300px;
        padding: 20px;
      }
    }

    .lock-comp .lock-section .qr-outer {
        margin-top: -80px;
  
      }
  }
  
  @media screen and (max-width: 800px) {
    .lock-comp {
      .lock-section {
        .desktop-view {
          display: none;
        }
  
        .mobile-view {
          display: block;
  
          .scan-qr-card {
            text-align: center;
            // margin-top: 70px;
  
            .rupee {
              font-size: 22px;
              margin-top: 7px;
            }
          }
        }
  
        .note {
          display: flex;
          justify-content: center;
  
          .promotional-banner-image {
            justify-content: flex-start !important;
          }
        }
      }
    }
  }
  
  @media screen and (max-width: 770px) {
    .lock-comp {
      .lock-section {
        .note {
          .features {
            margin-top: 0;
  
            .points {
              font-size: 11px;
              margin: 10px 0;
            }
          }
        }
  
        .prelogin-box {
          justify-content: flex-start;
        }
      }
    }
  
    .lock-comp .lock-section .pre-login-points {
      width: 400px;
      margin: auto;
    }
  
    .login-red-txt {
      margin-top: 10px;
    }
  
    .lock-comp .lock-section .gradient-text {
      margin-bottom: 10px;
    }
  }
  
  @media screen and (max-width: 725px) {
    .lock-comp .lock-section {
      .scan-qr-card {
        width: 360px;
        border-radius:10px !important;
      }
  
      .qr-outer {
        padding: 0 0px;
        margin-top: -20px;
        background-color:#2D2E8D;
  
        .left-section .list {
          margin: 10px 0;
          font-size: 12px;
        }
  
        .left-section .gradient-text {
          font-size: 15px;
        }
      }
    }
  
    .lock-comp .lock-section .note .features .points {
      margin: 5px 0;
    }
  }
  
  @media screen and (max-width: 590px) {
    .lock-comp .new-presignup-card {
      .offer-img {
        top: -20px;
        width: 100%;
      }
  
      .right-section {
        width: 260px;
      }
    }
  
    .lock-comp {
      .lock-section {
        .note {
          .promotional-banner-image {
            justify-content: center !important;
            width: 100vw;
            height: 75px;
            padding: 5px;
  
            .more-content {
              gap: 0px;
              padding: 0px;
            }
  
            .limited-offer-img {
              width: 100px;
            }
  
            .main-text {
              font-size: 9px;
              font-weight: 800;
              padding: 5px;
            }
  
            .discount-offer-img {
              width: 100px;
            }
          }
        }
  
        .prelogin-box {
          justify-content: flex-start;
        }
      }
    }
  }
  
  @media screen and (max-width: 455px) {
    .lock-comp {
      .lock-section {
        .scan-qr-card {
          width: 100%;
        }
  
        .pre-login-points,
        .login-card {
          width: 100%;
        }
      }
  
      .new-presignup-card {
        .offer-img {
          top: -12px;
          width: 107%;
        }
      }
    }
  }
  </style>
  <style lang="scss">
  @import '../css/variable.scss';
  @import '../css/common.scss';
  
  .new-presignup-card {
    .el-card {
      border-radius: 8px;
    }
  }
  
  .access-code-section {
    .el-input--mini .el-input__inner {
      border-radius: 7px;
    }
  }
  
  .unsubscribe-plan-notification-dialog {
    .el-dialog {
      border-radius: 10px;
    }
  }
  
  .left-section {
    .list {
      margin: 7px 0;
      font-size: 10px;
      font-weight: 500;
  
      .el-icon-success {
        background-image: linear-gradient(to right, #409eff, #2d2e8d);
        // #2488fe,
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
  
  .lock-comp {
    .login-card {
      width: 40%;
  
      .el-card {
        border-radius: 8px;
      }
  
      .el-card__body {
        padding: 30px 20px;
      }
    }
  
    .agreement {
      .el-checkbox__inner {
        border-color: #2d2e8d;
      }
  
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #303133;
      }
  
      .el-checkbox__input.is-disabled + span.el-checkbox__label {
        color: #c0c4cc;
        cursor: not-allowed;
        font-size: 10px;
      }
  
      .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
        background-color: #2d2e8d;
        border-color: #2d2e8d;
      }
  
      .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
        border-color: #ffffff;
      }
    }
  
    .el-checkbox__inner {
      width: 12px;
      height: 12px;
    }
  
    .el-checkbox__inner::after {
      -webkit-box-sizing: content-box;
      box-sizing: content-box;
      content: '';
      height: 6px;
      left: 3px;
      top: 0px;
    }
  
    .mobile-verification-dialog {
      .el-dialog {
        border-radius: 10px;
        width: 500px;
      }
  
      .el-dialog__header {
        background-color: $secondary-theme-color;
        border-radius: 10px 10px 0 0;
        text-align: center;
        padding: 20px;
      }
  
      .el-dialog__title {
        color: #ffff;
        font-weight: 600;
      }
  
      .top-head {
        font-size: 14px;
        color: #000;
        font-weight: 500;
      }
  
      .norml-txt {
        font-size: 15px;
        color: #000;
        font-weight: 600;
      }
  
      .el-input__inner {
        border: none;
        border-bottom: 1px solid gray;
        border-radius: 0;
        text-align: center;
        color: #000;
        font-weight: 600;
      }
  
      .el-dialog__body {
        padding: 30px;
      }
  
      .otp-btn {
        // border-radius: 4px;
        margin-top: 50px;
        font-weight: 600;
        padding: 10px 30px;
      }
  
      .el-dialog__headerbtn .el-dialog__close {
        color: #ffffff;
      }
    }
  
    .qr-dialog {
      .el-dialog {
        margin-top: 10px !important;
      }
  
      .el-dialog__headerbtn .el-dialog__close {
        position: relative;
        bottom: 7px;
      }
    }
  
    .el-checkbox__input.is-disabled + span.el-checkbox__label {
      color: #c0c4cc;
      cursor: not-allowed;
      font-size: 10px;
      padding-left: 5px;
      position: relative;
      bottom: 2px;
    }
  
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
      background-color: #a0cdfb;
      border-color: #a0cdfb;
    }
  
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
      border-color: #ffffff;
    }
  }
  
  .lock-comp .lock-section {
    .scan-qr-card {
      .el-card__body {
        padding: 12px 20px;
      }
    }
  }
  
  @media screen and (max-width: 770px) {
    .lock-comp .lock-section {
      .prelogin-box {
        .el-card__body {
          padding: 5px 20px 20px;
        }
  
        .el-card {
          margin-top: 10px;
        }
      }
    }
  }
  </style>
  